<template>
  <div class="shadow-sm rounded-xl border">
    <div class="flex p-3">
      <img :src="data.logo" alt="" class="w-8 h-8 rounded-full mr-2" />
      <div>
        <h3 class="text-sm font-medium text-black">{{ data.name }}</h3>
        <!-- <p class="text-xs font-medium text-606770">Sponsored</p> -->
      </div>
    </div>
    <div class="mb-2" :class="{clamp: primaryTextClamp}" @click="togglePrimaryTextClamp">
      <p class="text-x p-3 pt-0 leading-4 whitespace-pre-wrap font-sans tracking-tight">
        {{ data.primary_text }}
      </p>
    </div>
    <div>
      <div class="square" v-if="typeof data.media_source == 'string'">
        <video
          class="w-full"
          controls
          v-if="data.media_source.includes('.mp4')"
        >
          <source :src="data.media_source" type="video/mp4" />
        </video>
        <img
          :src="data.media_source"
          alt=""
          class="advertisements__item__media"
          v-if="
            data.media_source.includes('.png') ||
              data.media_source.includes('.jpg') ||
              data.media_source.includes('.jpeg')
          "
        />
      </div>
    </div>
    <div class="flex justify-between items-center p-3">
      <div class="w-56 text-s">
        <p>{{ data.display_link }}</p>
        <p>{{ data.description }}</p>
        <p>{{ data.headline }}</p>
      </div>
      <button class="action">{{ data.call_to_action }}</button>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
export default {
  props: {
    data: Object,
  },
  setup() {

    const primaryTextClamp = ref(true);

    const togglePrimaryTextClamp = () => {
      primaryTextClamp.value = !primaryTextClamp.value
    }

    return { primaryTextClamp, togglePrimaryTextClamp };
  },
};
</script>

<style>
.text-606770 {
  color: #606770;
}
.square {
  width: 100%;
  background-color: black;
}
.clamp {
  max-height: calc(1rem * 7);
  display: -webkit-box;
  -webkit-line-clamp: 7;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.action {
  max-width: 100px;
  letter-spacing: normal;
  color: rgb(68, 73, 80);
  font-size: 12px;
  font-weight: bold;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, Arial, sans-serif;
  line-height: 26px;
  text-align: center;
  background-color: rgb(245, 246, 247);
  border-color: rgb(218, 221, 225);
  height: 28px;
  border-radius: 2px;

  background-position: 0 0;
  border: 1px solid;
  border-radius: 2px;
  box-shadow: none;
  box-sizing: border-box;
  cursor: pointer;
  -webkit-font-smoothing: antialiased;
  font-weight: bold;
  padding: 0 11px;
  position: relative;
  text-shadow: none;
  transition: all 300ms cubic-bezier(0.1, 0.7, 0.1, 1), border-width 1ms;
  transition-property: background, border-color, border-width, color;
  vertical-align: middle;
}
</style>
